<template>
	<a-locale-provider  :locale="locale">
		<div id="app">
			<div class="test test-1">
				<div class="scrollbar"></div>
			</div>
			<Header ></Header>
			<!-- <Menu style="top: 500px !important;"></Menu> -->
			<multiTab v-show="false"></multiTab>
			<!-- <keep-alive v-if="isRouterAlive">
				<router-view v-if="cache=='open'"/>
			</keep-alive> -->
			<!-- <router-view v-if="cache=='close'&&isRouterAlive"/>
			<router-view v-if="!cache&&isRouterAlive"/> -->
			<!-- <router-view/> -->
			<keep-alive v-if="isRouterAlive"  :include="includeData">
				<router-view class="animate__animated animate__fadeIn" style="animation-duration: 0.5s;"></router-view>
			</keep-alive>
			<loading></loading>
			<a-back-top />
			<Footer></Footer>
		</div>
	</a-locale-provider>
</template>

<style lang="scss">
	#app {
		height: auto;
		// min-width: 89.9375rem;
		 min-width: 1400px;
		position: relative;
		width: 100%;
	}

	html,
	body {
		height: 100%;
		width: 100%;

	}
	.ant-pagination{
		display: none;
	}
	.ant-message-notice-content{
		// position: fixed;
		// top: 500px;
		transform: scale(1.2) !important;
		
	}
	.ant-message{
		top:5% !important;
	}
	/* 设置滚动条的样式 */
		::-webkit-scrollbar {
			width: 8px !important;
			height: 12px;
			background-color: #EEEEEE !important; 
			border-radius: 10px;
			
		}
	
		/* 滚动槽 */
		::-webkit-scrollbar-track {
			-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
			border-radius: 10px;
			
		}
	
		/* 滚动条滑块 */
		::-webkit-scrollbar-thumb {
			
			border-radius: 10px;
			width: 1px;
			border: 1px solid transparent !important;
			background: #B9B9B9 !important;
			-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
		}
	
		::-webkit-scrollbar-thumb:window-inactive {
			background: transparent !important;
			
		}
</style>
<script>
	import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
	import Header from './components/common/header.vue'
	import Menu from './components/common/menu.vue'
	import Footer from './components/common/footer.vue'
	import loading from './components/common/loading.vue'
	import multiTab from './components/multiTab.vue'
	export default {
		name: 'app',
		components: {
			Menu,
			Header,
			Footer,
			loading,
			multiTab
		},
		provide(){
		    return{
		      reload:this.reload
		    }
		  },
		  created() {
		  	console.log(this.panes)
			let includeData = []
			this.panes.map((n)=>{
				if(n.onlyCache==true){
					let ipos = n.key.indexOf("?")//指定开始的字符串
					if(ipos!=-1){
							n.key =  n.key.substring(0,ipos)
					}
				
				
					includeData.push(n.key)
				}
			})
			console.log(includeData)
			this.includeData = includeData
			window.sessionStorage.setItem('includeData',JSON.stringify(this.includeData))
		  },
		data() {
			return {
				isRouterAlive:true,
				locale: zhCN,
				includeData:[],
				cache:window.sessionStorage.getItem('cache'),
				panes:JSON.parse(window.sessionStorage.getItem('panes'))
			};
		},
		 methods:{
		    reload(){
		      this.isRouterAlive=false;
		      this.$nextTick(function(){
		        this.isRouterAlive=true
		      })
		    }
		  }
		

	}
</script>
